// Constants
import { PeriodicityTypes } from '@constants/Periodicity';

export const isMonthly = (periodicity: string | undefined): boolean => {
    if (!periodicity) {
        return true;
    }
    return periodicity === PeriodicityTypes.MONTHLY;
};
